import React, {Fragment, useState} from "react";
import {Button, Col, Modal, Row} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import RestClient from "../../RestAPI/RestClient";
import AppUrl from "../../RestAPI/AppUrl";
import cogoToast from "cogo-toast";
import LoadingText from "../Loading/LoadingText";
import {useSelector} from "react-redux";
import appUtility from "../../RestAPI/AppUtility";
import AppUtility from "../../RestAPI/AppUtility";


export default function NegativeReport(){
    let state=useSelector((state)=> state);
    const [DivisionEfd, setDivisionEfd]=useState([]);
    const [CircleEfd, setCircleEfd]=useState([]);
    const [DataCoEffeciant, setDataCoEffeciant]=useState([]);
    const [ColumnCoEfficient, setColumnCoEfficient]=useState([{}]);
    const [DataLength, setDatalength]=useState(0)
    const[DataStatus, setDataStatus]=useState(false)
    const[Reasons, setReasons]=useState([]);
    const [DataReportRevenueHistory, setDataReportRevenueHistory]=useState([]);
    const [ColumnReportRevenueHistory, setColumnReportRevenueHistory]=useState([{}]);
    const[Bin, setBin]=useState();
    const[Name, setName]=useState();
    const[Id, setId]=useState();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [showNegative, setShowNegative] = useState(false);
    const handleCloseNegative = () => setShowNegative(false);
    const handleShowNegative = () => setShowNegative(true);

    const [showReportRevenueHistory, setShowReportRevenueHistory] = useState(false);

    const handleCloseReportRevenueHistory = () => setShowReportRevenueHistory(false);
    const handleShowReportRevenueHistory = () => setShowReportRevenueHistory(true);

    const selectRow={
        mode:'radio',
        onSelect:(row,isSelect,rowIndex)=>{
            setBin(row['BIN']);
            setName(row['Name']);
            setId(row['Id']);
            setReasons("")
            handleShow();

        }
    }

    const getBIN=()=>{
        setDataStatus(true);
        setDatalength(0);
        const CommiEFD=document.getElementById("cmbEFDBinCommi");
        const CommiEFDValue=CommiEFD.options[CommiEFD.selectedIndex].text;
        const DivisionEFD=document.getElementById("cmbEFDDivision");
        const DivisionEFDValue=DivisionEFD.options[DivisionEFD.selectedIndex].text;
        const CircleEFD=document.getElementById("cmbEFDBinCircle");
        const CircleEFDValue=CircleEFD.options[CircleEFD.selectedIndex].text;

        const RangeEFD=document.getElementById("cmbEFDBinRange");
        const RangeEFDValue=RangeEFD.options[RangeEFD.selectedIndex].text;

        const BinCategoryEFD=document.getElementById("cmbEFDBinCategory");
        const CategoryEFDValue=BinCategoryEFD.options[BinCategoryEFD.selectedIndex].text;

        const NegativeMonth=document.getElementById("cmbMonth");
        const NegativeMonthValue=NegativeMonth.options[NegativeMonth.selectedIndex].text;

        const ItemsEfd=document.getElementById("cmbItemsEfd");
        const ItemsEfdValue=ItemsEfd.options[ItemsEfd.selectedIndex].text;
        const NameEfd=document.getElementById("txtSearchNameEfd").value;
        const BinEfd=document.getElementById("txtSearchBinEfd").value;

        const BinWise=document.getElementById("cmbBinWise");


        const EFDDataLimit=document.getElementById("cmbEFDDataLimit");
        const EFDDataLimitValue=EFDDataLimit.options[EFDDataLimit.selectedIndex].text;

        let getCommiEFD=" ";
        let getDivisionEFD=" ";
        let getCircleEFD=" ";
        let getRangeEFD=" ";
        let getCategoryEFD=" ";
        let getItemsEfd=" ";
        let getNameEfd=" ";
        let getBinEfd=" ";
        let getMonth=" ";
        let getLimit=" ";

        if(state.accessCom=="NBR")
        {if(CommiEFD.selectedIndex!=0){getCommiEFD="And Commissionerate Like '%"+CommiEFDValue+"%'"}}
        else{getCommiEFD="And Commissionerate Like '%"+state.accessCom+"%'"}

        if(state.accessDiv=="All Division")
        {if(DivisionEFD.selectedIndex!=0){getDivisionEFD="And Division Like '%"+DivisionEFDValue+"%'"}}
        else{getDivisionEFD="And Division Like '%"+state.accessDiv+"%'"}

        if(state.accessCir=="All Circle")
        {if(CircleEFD.selectedIndex!=0){getCircleEFD="And Circle Like '%"+CircleEFDValue+"%'"}}
        else {getCircleEFD="And Circle Like '%"+state.accessCir+"%'"}




        if(RangeEFD.selectedIndex!=0){getRangeEFD="And Range_Name= '"+RangeEFDValue+"'"}
        if(NegativeMonth.selectedIndex!=0){getMonth="And Month= '"+NegativeMonthValue+"'"}

        if(BinCategoryEFD.selectedIndex!=0){getCategoryEFD="And Economic_Activity Like '%"+CategoryEFDValue+"%'"}
        if(ItemsEfd.selectedIndex!=0){getItemsEfd="And Category= '"+ItemsEfdValue+"'"}
        if(NameEfd!=" "){getNameEfd="And Name Like '%"+NameEfd+"%'"}
        if(BinEfd!=" "){getBinEfd="And BIN Like '%"+BinEfd+"%'"}
        if(EFDDataLimit.selectedIndex!=0){getLimit= "LIMIT " +EFDDataLimitValue}
        let jsonObject="" ;

        if(BinWise.selectedIndex==0){jsonObject={"sql":" Select Id,Circle,Range_name,BIN,Name,Category,Items,Month,25_Month,25_Month_Upto,24_Month,24_Month_Upto,Month_Diff,Upto_Diff,Month_Growth,Upto_Growth from negative_bin_view where 1=1   "+getDivisionEFD+" "+getCircleEFD+" "+getBinEfd+" "+getRangeEFD+" "+getNameEfd+" "+getMonth+" "+getLimit+" "}
        }else if(BinWise.selectedIndex==1){
            jsonObject={"sql":"Select Id,Type,Month,Category,BIN_No,25_Month,25_Month_Upto,24_Month,24_Upto,Month_Diff,Upto_Diff,Month_Growth,Upto_Growth from Negative_Category_Revenue "}

        }

        setColumnCoEfficient([{}]);setDataCoEffeciant([])
        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{
            setDatalength(result.length);
            setDataStatus(false);
            if(result==""){cogoToast.error("Data not found")}else {
                await setColumnCoEfficient(
                    Object.keys(result[0]).map((k) => {
                        return {dataField: k, text: k, sort: true}
                    })
                )
                await setDataCoEffeciant(result);
                setDataStatus(false);

            }
        }).catch(error=>{});
    }
    const getHistory=()=>{
                setReasons("")
        const BinWise=document.getElementById("cmbBinWise");
        let jsonObject="" ;

        if(BinWise.selectedIndex==0){jsonObject={"sql":" SELECT Id,Reasons FROM Negative_BIN where Id='"+Id+"'  "};}
        else if(BinWise.selectedIndex==1){jsonObject={"sql":" SELECT Id,Reasons FROM Negative_BIN where Id='"+Id+"'  "};}


        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{

            if(result==""){cogoToast.error("Data not found");}else {
                setReasons(result[0].Reasons);
                setShow(true);

            }
        }).catch(error=>{ });

    }
    const getRevenueHistory=(status)=>{
        let jsonObject="";
        if(status==0){
            jsonObject={"sql":" SELECT July_24,July_25,August_24,August_25,September_24,September_25,October_24,October_25,November_24,November_25,December_24,December_25,January_25,January_26,February_25,February_26,March_25,March_26,April_25,April_26,May_25,May_26,June_25,June_26" +
                    ",(July_24+August_24+September_24+October_24+November_24+December_24+January_25+February_25+March_25+April_25+May_25+June_25)As Total_Last_Year," +
                    "(July_25+August_25+September_25+October_25+November_25+December_25+January_26+February_26+March_26+April_26+May_26+June_26)As Total_Upto FROM nbr.revenue_25_26_view where BIN='"+Bin+"' "};

        }else if(status==1){
            jsonObject={"sql":" select FY,Month,round(Closing_balance_vat/Deposited_vat,1)AS Balance_TR,round(Total_Payable_VAT/Deposited_vat,1)AS Payable_TR,`Deposite_%`,`Rebate_%`,`Decreasing_%`,Total_Sales_Value,Total_Payable_Vat,Total_Payable_SD,Total_Input_Tax_Credit_Value,Total_Input_Tax_Credit_VAT,Increasing_Adjustment,Decreasing_Adjustment,Net_Payable_VAT,Net_Payable_SD,Deposited_VAT,Deposited_SD,Closing_Balance_VAT,Closing_Balance_SD,VDS_Increasing,VDS_Decreasing,AT_Paid from Revenue_Analyse_View where BIN='"+Bin+"' order by Month_Code Desc "};

        }else if(status==2){
            jsonObject={"sql":" SELECT HSCODE,Description As Description_Of_Goods,Supply_Qty,Supply_Unit As Unit,Rm_Price,Addition_Price,Addition_Parcentage AS 'Add_%',Total_Price,Entry_Date As 'Effect_Date',DATEDIFF(CURDATE(),Entry_Date) AS Total_Days,Entry_Date,Status,Sale_Category,Comments As Comments_for_goods FROM `Co_Efficient` where BIN='"+Bin+"' "};

        }else if(status==3){
            jsonObject={"sql":" SELECT Court,Mamla_No,Mamla_Year,Mamla_Type,Amount,Status from Mamla where BIN='"+Bin+"' "};

        } else if(status==4) {
            jsonObject = {"sql": " SELECT Id, Reasons from negative_bin where BIN='" + Bin + "' "};

        }else if(status==5){
                jsonObject={"sql":" SELECT Officer,Entry_time As Visit_Date,Lat_lang As Map_Cords from Visit_BIN where BIN='"+Bin+"' "};

            } else if(status==6){
            jsonObject={"sql":" SELECT * from debt_report where BIN='"+Bin+"' "};

        }else if(status==7){
            jsonObject={"sql":" SELECT Bill_year,Bill_Month,Consumption_Unit,Unit_Price AS price,Entry_Officer,Entry_Date from Electricity_Data where BIN='"+Bin+"' "};

        }else if(status==8){
            jsonObject={"sql":" SELECT Caller,Call_Date,Comments from Call_Data where BIN='"+Bin+"' "};

        }else if(status==9){
            jsonObject={"sql":" SELECT SMS_Date,SMS_Sender,SMS from Sms_data where BIN='"+Bin+"' "};

        }



        setColumnReportRevenueHistory([{}]);setDataReportRevenueHistory([])
        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{

            if(result==""){cogoToast.error("Data not found");}else {
                await setColumnReportRevenueHistory(
                    Object.keys(result[0]).map((k) => {
                        return {dataField: k, text: k, sort: true}
                    })
                )
                await setDataReportRevenueHistory(result);

                handleShowReportRevenueHistory();

            }
        }).catch(error=>{ });

    }
    const getNegativeReason=()=>{

        let jsonObject={"sql":" SELECT Id,Reasons from negative_bin where BIN='"+Bin+"'  "};

        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{

            if(result==""){cogoToast.error("Data not found");}else {
                setReasons(result[0].Reasons);
                setShowNegative(true);

            }
        }).catch(error=>{ });

    }
    const updateReasons=()=>{
            const ResonsData=document.getElementById("txtAreaReasons").value;

            if(ResonsData==""){cogoToast.error("Please insert Reasons")}else{

        RestClient.PostRequest(AppUrl.updateData, {"sql": "Update Negative_BIN set Reasons='"+ResonsData+"' where ID='"+Id+"' "}).then(result => {
            if (result == 1) {
                cogoToast.success("Reasons Data saved")

            } else {
                cogoToast.error("Reasons Data not saved")
            }
        }).catch(error => {
            cogoToast.error(error)
        });

    }}


    return(
        <Fragment>
            <div >
                <Row className="mt-2">

                    <Col lg={3}>
                        <div className="">
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">NBR</label></Col>
                                <Col lg={9}  xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbEFDBinCommi"
                                            onChange={()=>{
                                                setDivisionEfd([]);
                                                setCircleEfd([]);
                                                const e = document.getElementById("cmbEFDBinCommi");
                                                const value = e.options[e.selectedIndex].value;
                                                const dt=state.division.filter(x => x.Commissionerate_Id==value);
                                                setDivisionEfd(dt)


                                            }}
                                    >




                                        <option >NBR</option>



                                        {


                                            state.commi.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }
                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Division</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbEFDDivision"
                                            onChange={()=>{
                                                setCircleEfd([])
                                                const e = document.getElementById("cmbEFDDivision");
                                                const value = e.options[e.selectedIndex].value;
                                                const dt=state.circle.filter(x => x.Division_Id==value);
                                                setCircleEfd(dt)


                                            }}
                                    >
                                        <option>All Division</option>

                                        {


                                            DivisionEfd.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }


                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Circle</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbEFDBinCircle" >
                                        <option >All Circle</option>

                                        {


                                            CircleEfd.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }


                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Range</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbEFDBinRange"  >
                                        <option >All</option>
                                        <option >Range-1</option>
                                        <option >Range-2</option>
                                        <option >Range-3</option>
                                        <option >Range-4</option>
                                        <option >Range-5</option>
                                        <option >Range-6</option>
                                        <option >Range-7</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Category</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbEFDBinCategory"  >
                                        <option >All BIN</option>
                                        <option >Manufacturing</option>
                                        <option >Services</option>
                                        <option >Other</option>
                                        <option >Imports</option>
                                        <option >Wholesale</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Items</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbItemsEfd"  >
                                        <option value="0">All Items</option>
                                        {
                                            state.category.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }

                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">BIN</label></Col>
                                <Col lg={9} xs={8}>
                                    <input type="text" className="w-100" id="txtSearchBinEfd"/>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Name</label></Col>
                                <Col lg={9} xs={8}>
                                    <input type="text" className="w-100" id="txtSearchNameEfd"/>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Month</label></Col>
                                <Col lg={9}xs={8}>
                                    <select   className="float-start w-100 customfontsize" id="cmbMonth">
                                        <option >All</option>
                                        <option >July</option>
                                        <option >August</option>
                                        <option >September</option>
                                        <option >October</option>
                                        <option >November</option>
                                        <option >December</option>
                                        <option >January</option>
                                        <option >February</option>
                                        <option >March</option>
                                        <option >April</option>
                                        <option >May</option>
                                        <option >June</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Data Limit</label></Col>
                                <Col lg={9}xs={8}>
                                    <select defaultValue={100} className="float-start w-100 customfontsize" id="cmbEFDDataLimit"  >
                                        <option >All</option>
                                        <option >50</option>
                                        <option >100</option>
                                        <option >200</option>
                                        <option >500</option>
                                        <option >1000</option>
                                        <option >2000</option>
                                        <option >3000</option>
                                        <option >5000</option>
                                        <option >10000</option>
                                        <option >20000</option>
                                        <option >50000</option>


                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Data Limit</label></Col>
                                <Col lg={9}xs={8}>
                                    <select  className="float-start w-100 customfontsize" id="cmbBinWise"  >
                                        <option >BIN</option>
                                        <option >Category</option>


                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}>

                                </Col>
                                <Col lg={9}>
                                    <button className="w-100" onClick={getBIN}>Search</button>
                                </Col>


                            </Row>


                        </div>
                    </Col>

                    <Col lg={9}>
                        <div className="overflow-scroll animated zoomIn purchaseMedium2Div">

                            {
                                DataStatus?<LoadingText/>
                                    :  <BootstrapTable selectRow={selectRow}  keyField='Id'  data={DataCoEffeciant} columns={ColumnCoEfficient}></BootstrapTable>

                            }
                        </div>
                        <label className="text-danger customfontsize">Data found: {DataLength}</label>

                    </Col>

                </Row>

            </div>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>  <label>{Name}</label></Modal.Title>

                </Modal.Header>
                <Modal.Body>

                      <div className="w-75"><Button className="" variant="primary" onClick={()=>getRevenueHistory(5)} >Visit History</Button></div><hr className="mb-1"/>
                    <div className="w-75">
                        <Button className="" variant="danger" onClick={()=>getRevenueHistory(0)} >Revenue History</Button> <label></label>
                        <Button className="" variant="primary" onClick={()=>getRevenueHistory(1)} >Revenue Analysis</Button>
                    </div><hr className="mb-1"/>
                    <div className="w-75"><Button className="" variant="primary" onClick={()=>getRevenueHistory(3)} >Mamla History</Button></div><hr className="mb-1"/>
                    <div className="w-75"><Button className="" variant="secondary" onClick={()=>getRevenueHistory(6)}>Debt History</Button></div><hr className="mb-1"/>
                     <div className="w-75">
                        <Button className="" variant="primary" onClick={()=>getRevenueHistory(2)} >4.3</Button><label> __</label>
                        <Button className="" variant="primary" onClick={getNegativeReason} >Negative history</Button>

                    </div><hr className="mb-1"/>

                     </Modal.Body>
                <Modal.Footer>

                    <Button className="" variant="primary" onClick={()=>getRevenueHistory(7)} >Electricity Bill</Button>
                    <Button className="" variant="primary" onClick={()=>getRevenueHistory(8)} >Call log</Button>
                    <Button className="" variant="primary" onClick={()=>getRevenueHistory(9)} >SMS log</Button>


                </Modal.Footer>
            </Modal>

            <Modal show={showReportRevenueHistory} onHide={handleCloseReportRevenueHistory} dialogClassName="custom-modal-width">
                <Modal.Header closeButton>

                    <label>{Name}</label>

                </Modal.Header>
                <Modal.Body className="scrollable-x">
                    <div className="wide-content">
                        {<BootstrapTable  keyField='Id'  data={DataReportRevenueHistory} columns={ColumnReportRevenueHistory}></BootstrapTable>}
                    </div>

                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={handleCloseReportRevenueHistory}>
                        Close
                    </Button>


                </Modal.Footer>
            </Modal>

            <Modal show={showNegative} onHide={handleCloseNegative} dialogClassName="custom-modal-width">
                <Modal.Header closeButton>

                    <label>{Name}</label>

                </Modal.Header>
                <Modal.Body className="scrollable-x">
                    <div className="wide-content">
                            <textarea rows="8"  className="w-100">{Reasons}</textarea>
                    </div>
                    <div className="wide-content">
                        <textarea rows="8" id="txtAreaReasons" className="w-100"></textarea>
                    </div>

                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={handleCloseNegative}>
                        Close
                    </Button>
                    <Button onClick={updateReasons}>Update Data</Button>

                </Modal.Footer>
            </Modal>
        </Fragment>

    )
}
